import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/organisms/Table';
import { isEmptyArray } from '../../../lib/typeGuards';
import { Statistics, StatisticTypes } from '../ContentSearchStatistics.types';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { ContentLink } from '../../../_lib/components/ContentLink';
import { Strong } from '../../../components/atoms/Strong/Strong';

export type ContentSearchStatisticsTableProps = {
  statistics: Statistics[];
  type: StatisticTypes;
};

export function ContentSearchStatisticsTable({ statistics, type }: ContentSearchStatisticsTableProps) {
  const { t } = useSonTranslation('ContentSearchStatistics');

  const searchQuery = t('statistics.searchQuery');
  const totalSearchQueriesCount = t('statistics.totalSearchQueriesCount');
  const instantSearchQueriesPercentage = t('statistics.instantSearchQueriesPercentage');
  const filteredSearchQueriesPercentage = t('statistics.filteredSearchQueriesPercentage');
  const searchResultsCount = t('statistics.searchResultsCount');

  if (isEmptyArray(statistics)) {
    return null;
  }

  function getCaption() {
    return (
      <>
        <Strong>{t(`lastContentSearches.${type}`)}</Strong>
        {` ${t('lastContentSearches.withoutToday')}`}
      </>
    );
  }

  function replaceDotToComma(searchCount: number): string {
    const searchCountString = searchCount.toString();
    if (searchCountString.includes('.')) {
      return searchCountString.replace('.', ',');
    }
    return searchCountString;
  }

  return (
    <div className="content-search-statistics">
      <Table caption={getCaption()} captionHidden={false}>
        <TableHead>
          <TableRow>
            <TableCell modifier={['lowpadding', 'width-170']}>{searchQuery}</TableCell>
            <TableCell modifier={['align-right', 'lowpadding', 'width-150']}>{totalSearchQueriesCount}</TableCell>
            <TableCell modifier={['align-right', 'lowpadding']}>{instantSearchQueriesPercentage}</TableCell>
            <TableCell modifier={['align-right', 'lowpadding', 'width-150']}>
              {filteredSearchQueriesPercentage}
            </TableCell>
            <TableCell modifier={['align-right', 'lowpadding', 'width-190']}>{searchResultsCount}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statistics?.map(item => (
            <TableRow key={item.searchQuery + type}>
              <TableCell modifier={['lowpadding']} dataHead={searchQuery}>
                <ContentLink to={item.url.url}>{item.searchQuery}</ContentLink>
              </TableCell>
              <TableCell modifier={['align-right', 'lowpadding']} dataHead={totalSearchQueriesCount}>
                {replaceDotToComma(item.totalSearchQueriesCount)}
              </TableCell>
              <TableCell modifier={['align-right', 'lowpadding']} dataHead={instantSearchQueriesPercentage}>
                {t('searchQueriesPercentage', { percentage: replaceDotToComma(item.instantSearchQueriesPercentage) })}
              </TableCell>
              <TableCell modifier={['align-right', 'lowpadding']} dataHead={filteredSearchQueriesPercentage}>
                {t('searchQueriesPercentage', { percentage: replaceDotToComma(item.filteredSearchQueriesPercentage) })}
              </TableCell>
              <TableCell modifier={['align-right', 'lowpadding']} dataHead={searchResultsCount}>
                {t('searchResultsCountAvarage', {
                  mean: replaceDotToComma(item.searchResultsCount.mean),
                  min: replaceDotToComma(item.searchResultsCount.min),
                  max: replaceDotToComma(item.searchResultsCount.max),
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
